import { FileUploadDesignTokens } from '@primeuix/themes/types/fileupload';

export const FileUpload: FileUploadDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  colorScheme: {
    light: {
      root: {
        borderColor: '{surface.300}'
      },
    },
  },
};
